import { api } from './api';
import type {
  EmailTemplate,
  EmailTemplateFilter,
  EmailTemplateMacro,
  EmailTemplateTestPreview,
  PagedEmailTemplateResult,
  SendEmailTemplateTestPayload,
  SendEmailTemplateTestResult,
  UpsertEmailTemplateRequest,
} from '../types/emailTemplate';

class EmailTemplateService {
  async getAll(params: EmailTemplateFilter): Promise<PagedEmailTemplateResult> {
    const response = await api.get<PagedEmailTemplateResult>('/email-templates', { params });
    return response.data;
  }

  async getById(id: string): Promise<EmailTemplate> {
    const response = await api.get<EmailTemplate>(`/email-templates/${id}`);
    return response.data;
  }

  async create(payload: UpsertEmailTemplateRequest): Promise<EmailTemplate> {
    const response = await api.post<EmailTemplate>('/email-templates', payload);
    return response.data;
  }

  async update(id: string, payload: UpsertEmailTemplateRequest): Promise<EmailTemplate> {
    const response = await api.put<EmailTemplate>(`/email-templates/${id}`, payload);
    return response.data;
  }

  async remove(id: string): Promise<void> {
    await api.delete(`/email-templates/${id}`);
  }

  async sendTest(to: string): Promise<SendEmailTemplateTestResult> {
    const response = await api.post<SendEmailTemplateTestResult>('/email-templates/test', { to });
    return response.data;
  }

  async getTestPreview(id: string): Promise<EmailTemplateTestPreview> {
    const response = await api.get<EmailTemplateTestPreview>(`/email-templates/${id}/test-preview`);
    return response.data;
  }

  async sendTemplateTest(
    id: string,
    payload: SendEmailTemplateTestPayload
  ): Promise<SendEmailTemplateTestResult> {
    const response = await api.post<SendEmailTemplateTestResult>(`/email-templates/${id}/test`, payload);
    return response.data;
  }

  async getMacros(): Promise<EmailTemplateMacro[]> {
    const response = await api.get<EmailTemplateMacro[]>('/email-templates/macros');
    return response.data;
  }
}

export const emailTemplateService = new EmailTemplateService();
